module.exports = __webpack_public_path__ + "hero.755953fffa5cbcbb3746789437c27bec.png";


//////////////////
// WEBPACK FOOTER
// ./components/hero/assets/hero.png
// module id = LHot
// module chunks = 0